<template>
  <div class="dropdown-save" id="dropdown-save">
    <b-dropdown id="dropdown-right" right text="" variant="primary" class="">
      <b-dropdown-item
        id="saveAsItem"
        v-has-permission="'save_copie_html_action'"
        @click="saveAs"
        >{{ $t('template.save_as_copie') }}</b-dropdown-item
      >
      <b-dropdown-item id="saveAsVideo" v-has-permission="'save_video_action'" @click="saveVideo">{{
        $t('template.save_as_video')
      }}</b-dropdown-item
      ><!--v-if="displaySaveVideoButton"-->
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HasPermission from '../../core/directives/HasPermission.js';

export default {
  name: 'Save',
  directives: {
    HasPermission,
  },
  methods: {
    ...mapActions('common', ['setShowSave', 'setSaveVideo']),
    saveAs() {
      this.setShowSave(true);
    },
    saveVideo() {
      this.setSaveVideo(true);
    },
  },
};
</script>

<style lang="scss">
.dropdown-save {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
}
button#dropdown-right__BV_toggle_,
button#dropdown-right__BV_toggle_ :hover {
  background: transparent !important;
  width: 10px !important;
  text-align: right !important;
  margin-right: 14px !important;
  border: none !important;
  height: 32px;
  top: 2px !important;
  padding-left: 0 !important;
  &:focus {
    box-shadow: none !important;
  }
}
.dropdown-item {
  padding: 0.5rem 1.5rem !important;
}
</style>



// WEBPACK FOOTER //
// Save.vue?320bf2a0